@if (href) {
  <a [href]="href">
    <ng-container *ngTemplateOutlet="navigationItemContent" />
  </a>
} @else {
  <a [routerLink]="routerLink">
    <ng-container *ngTemplateOutlet="navigationItemContent" />
  </a>
}

<ng-template #navigationItemContent>
  @if (icon != null) {
    <shared-icon class="fill-dark" [icon]="icon" [width]="iconSize" [height]="iconSize" />
  } @else {
    <span></span>
  }
  <span class="text-14">{{ label }}</span>
  <shared-icon class="fill-primary" icon="triangle-right" width="1rem" height="1rem" />
</ng-template>
